import { graphql } from "../gql";

export const validateRuleCodeQueryDoc = graphql(`
  query validateRuleCode($input: ValidateRuleCodeInput!) {
    validateRuleCode(input: $input) {
      status
      message
      isValid
      selectCodeErrors {
        codeCompilationError
        safetyViolations
        missingMethods
        expectedMethodSignatures
        invalidAttributeAccesses
      }
      evaluateCodeErrors {
        codeCompilationError
        safetyViolations
        missingMethods
        expectedMethodSignatures
        invalidAttributeAccesses
      }
    }
  }
`);
